import { deleteCodeActivity } from '@/data/services/activityElement/codeServices';
import { deleteDndOrdenationActivity } from '@/data/services/activityElement/dndOrdenationActivityServices';
import { deleteDndPositionalActivity } from '@/data/services/activityElement/dndPositionalActivityServices';
import { deleteQuizActivity } from '@/data/services/activityElement/quizServices';
import { deleteTextActivity } from '@/data/services/_deprecated/textActivityServices';
import { deleteTrueOrFalseActivity } from '@/data/services/activityElement/trueOrFalseActivityServices';
import { deleteVideoActivity } from '@/data/services/activityElement/videoActivityService';
import { ActivityTypeEnum } from '@/models/_deprecated/ActivityElement';
import ActivityElement from '@/models/_deprecated/ActivityElement';
import { deleteCodeEditorActivity } from '@/data/services/activityElement/codeEditorActivityServices';
import { deleteBlockActivity } from '@/data/services/activityElement/blockServices';

const deleteActivityByType = async ({ id, type }: ActivityElement) => {
  const routes: {
    [key in ActivityTypeEnum]: (questionId: number) => Promise<void>;
  } = {
    [ActivityTypeEnum.TEXT]: deleteTextActivity,
    [ActivityTypeEnum.VIDEO]: deleteVideoActivity,
    [ActivityTypeEnum.QUIZ]: deleteQuizActivity,
    [ActivityTypeEnum.TRUE_OR_FALSE]: deleteTrueOrFalseActivity,
    [ActivityTypeEnum.DND_ORDENATION]: deleteDndOrdenationActivity,
    [ActivityTypeEnum.DND_POSITIONAL]: deleteDndPositionalActivity,
    [ActivityTypeEnum.CODE]: deleteCodeActivity,
    [ActivityTypeEnum.CODE_EDITOR]: deleteCodeEditorActivity,
    [ActivityTypeEnum.BLOCK]: deleteBlockActivity,
  };
  const deleteActivityFunction = routes[type as keyof typeof routes];
  await deleteActivityFunction(id);
};

export default deleteActivityByType;
